(() => {
  'use strict';
  if (window.ebdVisualPairLoaded) return;
  window.ebdVisualPairLoaded = true;
  const catalogRequests = new Map();
  async function dataAt(url, selector) {
    const response = await fetch(url, {cache:'no-store'});
    if (!response.ok) throw new Error('Unable to load product options.');
    const element = new DOMParser().parseFromString(await response.text(), 'text/html').querySelector(selector);
    if (!element) throw new Error('Unable to load product options.');
    return JSON.parse(element.textContent);
  }
  const option = (title, value, disabled = false) => { const el = document.createElement('option'); el.textContent = title; el.value = value; el.disabled = disabled; return el; };
  function initialize(section) {
    if (section.dataset.vpReady) return;
    section.dataset.vpReady = 'true';
    const strings = JSON.parse(section.querySelector('[data-vp-strings]').textContent);
    const products = JSON.parse(section.querySelector('[data-vp-products]').textContent);
    const slots = [...section.querySelectorAll('[data-vp-slot]')];
    const form = section.querySelector('[data-vp-form]'), errorBox = section.querySelector('[data-vp-error]'), button = section.querySelector('[data-vp-submit]');
    const root = section.dataset.root.replace(/\/?$/, '/'), locked = section.dataset.lockFirst === 'true';
    let catalog = [], busy = false, syncing = false, count = 2;
    const modeButtons = [...section.querySelectorAll('[data-vp-count]')];
    const addLabel = () => count === 3 ? strings.add_three : strings.add;
    const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:section.dataset.currency || 'USD'}).format(cents / 100);
    const selected = i => products[i].variants.find(v => String(v.id) === slots[i].querySelector('[data-vp-size]').value);
    const price = i => selected(i)?.price ?? Math.min(...products[i].variants.map(v => v.price));
    function totals() {
      const rate = count === 3 ? .15 : .1;
      const prices = slots.slice(0,count).map((_,i) => price(i)), before = prices.reduce((a,b) => a+b, 0), after = prices.reduce((a,b) => a+b-Math.round(b*rate), 0);
      section.querySelector('[data-vp-before]').textContent = money(before);
      section.querySelector('[data-vp-total]').textContent = money(after);
      section.querySelector('[data-vp-discount]').textContent = money(before-after);
      section.querySelector('[data-vp-equation]').textContent = count === 3 ? strings.equation_three : strings.equation_two;
      const ready = slots.slice(0,count).filter((_,i) => selected(i)?.available).length;
      section.dataset.vpComplete = String(ready === count);
      section.querySelectorAll('.ebd-vp-meter i').forEach((segment,i) => { segment.hidden = i >= count; segment.classList.toggle('is-ready', i < ready); });
      section.querySelector('[data-vp-progress]').textContent = (ready === count ? strings.ready : strings.progress).replace('__READY__',String(ready)).replace('__COUNT__',String(count)).replace('__PERCENT__',String(Math.round(rate*100)));
      section.querySelector('[data-vp-saving]').textContent = strings.saving.replace('__AMOUNT__', money(before-after)).replace('__PERCENT__', String(Math.round(rate*100)));
    }
    function showVariant(i) {
      const v = selected(i);
      slots[i].querySelector('[data-vp-price]').textContent = money(price(i));
      slots[i].querySelector('[data-vp-delivery]').textContent = v ? v.delivery : strings.shipping;
      totals();
    }
    function showProduct(i, product, keep = '') {
      products[i] = product;
      const slot = slots[i], size = slot.querySelector('[data-vp-size]'), photo = slot.querySelector('.ebd-vp-photo img');
      photo.src = product.image; photo.removeAttribute('srcset'); photo.alt = product.title;
      slot.querySelector('[data-vp-details]').href = product.url;
      const name = slot.querySelector('[data-vp-name]'); name.href = product.url; name.textContent = product.title;
      size.replaceChildren(option(strings.choose, ''));
      product.variants.forEach(v => size.appendChild(option(v.title + (v.available ? '' : ' — '+strings.sold), String(v.id), !v.available)));
      if (product.variants.some(v => v.available && String(v.id) === keep)) size.value = keep;
      if (product.auto_select && product.variants[0]?.available) size.value = String(product.variants[0].id);
      showVariant(i);
    }
    function filter(i, preferred) {
      const slot = slots[i], fit = slot.querySelector('[data-vp-fit]').value, styles = slot.querySelector('[data-vp-style]');
      const matches = catalog.filter(p => fit === 'all' || p.fit === fit || (fit === 'kids' && p.kids) || (p.fit === 'both' && (fit === 'him' || fit === 'her')));
      styles.replaceChildren(...matches.map(p => option(p.title,p.handle)));
      if (matches.some(p => p.handle === preferred)) styles.value = preferred;
      const p = matches.find(p => p.handle === styles.value);
      if (p) showProduct(i,p,p.handle === products[i].handle ? slot.querySelector('[data-vp-size]').value : '');
    }
    async function loadCatalog() {
      try {
        const url = root+'collections/workshirts?section_id=ebd-pair-catalog';
        if (!catalogRequests.has(url)) catalogRequests.set(url,dataAt(url,'[data-ebd-pair-catalog]').catch(error => { catalogRequests.delete(url); throw error; }));
        catalog = await catalogRequests.get(url);
        slots.forEach((slot,i) => {
          const choices = slot.querySelector('[data-vp-fit]');
          if (!choices) return;
          [...choices.options].forEach(choice => {
            if (['vest','flannel','thermal','bag','bottoms','outerwear','footwear','accessories'].includes(choice.value)) choice.hidden = !catalog.some(p => p.fit === choice.value);
          });
          filter(i,products[i].handle);
        });
      } catch (_) { /* The two initial products remain fully shoppable if the catalog cannot load. */ }
    }
    slots.forEach((slot,i) => {
      if (i === 2 && products[i].fit === 'kids') slot.querySelector('[data-vp-fit]').value = 'kids';
      slot.querySelector('[data-vp-fit]')?.addEventListener('change',async () => { if (!catalog.length) await loadCatalog(); if (catalog.length) filter(i,products[i].handle); });
      slot.querySelector('[data-vp-style]')?.addEventListener('change',event => { const p = catalog.find(p => p.handle === event.target.value); if (p) showProduct(i,p); });
      slot.querySelector('[data-vp-size]').addEventListener('change',() => {
        errorBox.hidden = true; showVariant(i);
        if (i === 0 && locked && !syncing) {
          const v = selected(0); if (!v) return;
          syncing = true;
          document.querySelectorAll('.pdp .vals').forEach((group,index) => [...group.querySelectorAll('.vbtn')].find(b => b.dataset.val === v.options[index])?.click());
          syncing = false;
        }
      });
      showVariant(i);
    });
    modeButtons.forEach(control => control.addEventListener('click',() => {
      if (busy) return;
      count = Number(control.dataset.vpCount);
      section.dataset.vpCount = String(count);
      slots[2].hidden = count !== 3; slots[2].disabled = count !== 3;
      modeButtons.forEach(b => b.setAttribute('aria-pressed',String(b === control)));
      section.querySelector('[data-vp-offer]').textContent = count === 3 ? strings.offer_three : strings.offer;
      button.textContent = addLabel(); errorBox.hidden = true; totals();
    }));
    section.addEventListener('ebd:bundle-select',async event => {
      if (busy) return;
      if (!catalog.length) await loadCatalog();
      if (!catalog.length || busy) return;
      [event.detail?.first,event.detail?.second].forEach((handle,i) => {
        if (!handle || (i === 0 && locked) || !catalog.some(p => p.handle === handle)) return;
        slots[i].querySelector('[data-vp-fit]').value = 'all'; filter(i,handle);
      });
    });
    if (locked) {
      const syncPrimary = () => { const id = document.getElementById('pdp-id')?.value; if (products[0].variants.some(v => v.available && String(v.id) === id)) { slots[0].querySelector('[data-vp-size]').value = id; showVariant(0); } else { slots[0].querySelector('[data-vp-size]').value = ''; showVariant(0); } };
      document.querySelectorAll('.pdp .vals .vbtn').forEach(b => b.addEventListener('click',() => { if (!syncing) syncPrimary(); }));
      syncPrimary();
    }
    if ('IntersectionObserver' in window) { const observer = new IntersectionObserver(entries => { if (entries.some(e => e.isIntersecting)) { observer.disconnect(); loadCatalog(); } },{rootMargin:'300px'}); observer.observe(section); } else loadCatalog();
    form.addEventListener('submit',async event => {
      event.preventDefault(); if (busy || !form.reportValidity()) return;
      const choices = slots.slice(0,count).map((slot,i) => ({product:products[i],variant:selected(i)}));
      if (choices.some(x => !x.variant?.available)) return;
      busy = true; form.setAttribute('aria-busy','true'); modeButtons.forEach(b => b.disabled = true); button.disabled = true; button.textContent = strings.adding; errorBox.hidden = true;
      slots.forEach(slot => slot.disabled = true);
      let attempted = false;
      try {
        const fresh = await Promise.all(choices.map(x => dataAt(x.product.url+'?section_id=ebd-quick-add','[data-ebd-quick-product]')));
        let unavailable = false, changed = false;
        const items = new Map();
        choices.forEach((choice,i) => {
          const v = fresh[i].variants.find(v => String(v.id) === String(choice.variant.id));
          if (!v?.available) unavailable = true;
          else if (v.price !== choice.variant.price || v.delivery !== choice.variant.delivery) changed = true;
          showProduct(i,{...choice.product,variants:fresh[i].variants},String(choice.variant.id));
          if (v?.available) {
            const item = items.get(String(v.id));
            if (item) item.quantity += 1;
            else items.set(String(v.id),{id:v.id,quantity:1,properties:v.requires_shipping ? {Dispatch:v.delivery} : {}});
          }
        });
        if (unavailable) throw new Error(strings.unavailable);
        if (changed) throw new Error(strings.changed);
        if (!window.ebdDrawer?.addItems) throw new Error(strings.error);
        attempted = true;
        await window.ebdDrawer.addItems([...items.values()]);
        section.closest('dialog[open]')?.close();
        await window.ebdDrawer.open(false);
      } catch (error) {
        errorBox.textContent = attempted ? strings.error : error.message || strings.error; errorBox.hidden = false;
        if (attempted) { section.closest('dialog[open]')?.close(); await Promise.resolve(window.ebdDrawer.open()).catch(() => {}); }
      } finally { busy = false; form.setAttribute('aria-busy','false'); modeButtons.forEach(b => b.disabled = false); button.disabled = false; button.textContent = addLabel(); slots.forEach((slot,i) => slot.disabled = i >= count); }
    });
  }
  const boot = () => document.querySelectorAll('[data-visual-pair]').forEach(initialize);
  boot(); document.addEventListener('shopify:section:load',boot);
})();
